/* Family Ties PDP - add a matching tie as its own line, then open the cart drawer. */
(function () {
  var SECTION_ID = 'cart-drawer';

  document.body.addEventListener('click', function (event) {
    var btn = event.target.closest('.js-add-family-tie');
    if (!btn) return;
    event.preventDefault();
    if (btn.dataset.loading === '1') return;

    var variantId = Number(btn.dataset.variantId);
    var quantity = parseInt(btn.dataset.quantity || '1', 10) || 1;
    if (!variantId) return;

    // GA4: family-tie offer clicked
    if (window.gtag) {
      var row = btn.closest('.family-ties__item');
      var nameEl = row ? row.querySelector('.family-ties__name') : null;
      var params = { variant_id: variantId, location: 'pdp' };
      if (nameEl) params.item_name = nameEl.textContent.trim();
      gtag('event', 'family_ties_offer_click', params);
    }

    btn.dataset.loading = '1';
    btn.classList.add('is-loading');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          console.warn('[Family ties] add failed:', res.description || res.message);
          reset(btn);
          return;
        }
        refreshAndOpenDrawer();
        reset(btn);
      })
      .catch(function (err) { console.error('[Family ties] add error:', err); reset(btn); });
  });

  function reset(btn) {
    btn.dataset.loading = '';
    btn.classList.remove('is-loading');
  }

  function refreshAndOpenDrawer() {
    fetch(window.Shopify.routes.root + '?section_id=' + SECTION_ID)
      .then(function (r) { return r.text(); })
      .then(function (markup) {
        var doc = new DOMParser().parseFromString(markup, 'text/html');
        var newInner = doc.querySelector('.cart-drawer-inner');
        var currentInner = document.querySelector('cart-drawer .cart-drawer-inner');
        if (newInner && currentInner) currentInner.replaceWith(newInner);

        var newCount = doc.querySelector('.cart-count');
        if (newCount) {
          document.querySelectorAll('.cart-count').forEach(function (el) {
            el.textContent = newCount.textContent;
          });
        }

        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          if (typeof drawer.open === 'function') { drawer.open(); }
          else { drawer.setAttribute('aria-hidden', 'false'); drawer.classList.add('active'); }
        }
      })
      .catch(function (err) { console.error('[Family ties] add error:', err); reset(btn); });
  }
})();